



































import Vue from "vue";
import iwInputGroupStepper from "@/encoding/components/buildingBlocks/InputGroupStepper.vue";
import iwFloorAreaBedroom from "./FloorAreaBedroom.vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwHasDressingRoom from "./HasDressingRoom.vue";
import { mapGetters } from "vuex";

export default Vue.extend({

    components: {
        iwInputGroupStepper: iwInputGroupStepper,
        iwFloorAreaBedroom: iwFloorAreaBedroom,
        iwAccordion: iwAccordion,
        iwHasDressingRoom: iwHasDressingRoom
    },
    data: function () {
        return {
            bedroomCount: 0,
            maximumBedroomSurfaces: 5,
            pathInStore: "property.bedroom.count",
            internalBedroomSurface: 0,
            bedroomsSurfaces: [] as Array<Record<string,number>>
        };
    },
    computed: {
        ...mapGetters({
            isReadonlyField: "FormModule/isReadonlyField",
            editNotAllowed: "FormModule/editNotAllowed"
        }),
        editExpirationDate: function(): string | null {
            return this.$store.getters["FormModule/editExpirationDate"];
        },
        isDisplayed: function(): boolean {
            return ["HOUSE", "APARTMENT", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
    },
    watch: {
        bedroomCount: function(newValue: number, oldValue: number) {
            if(newValue < oldValue) {
                this.bedroomsSurfaces.splice((newValue),1);
                this.removeBedroomSurface();
            }
        },
    },
    created: function() {
        this.bedroomCount = this.$store.getters["FormModule/getValue"]("property.bedroom.count");
        this.bedroomsSurfaces = this.$store.getters["FormModule/getValue"]("property.bedroom.items") ? this.$store.getters["FormModule/getValue"]("property.bedroom.items") : this.bedroomsSurfaces;
        this.internalBedroomSurface = this.bedroomCount > 5 ? 5 : this.bedroomCount;
    },
    mounted: function(){
        if(this.$store.getters["FormModule/getValue"](this.pathInStore) == null && this.isDisplayed) {
            this.$store.dispatch("FormModule/addValue", {"path": "property.bedroom.count", "value": 0});
        }
    },
    methods: {
        updateValue: function(bedroomCount: number): void {
            this.$store.dispatch("FormModule/addValue", {"path": "property.bedroom.count", "value": bedroomCount});
            this.bedroomCount = bedroomCount;
            this.$store.dispatch("FormModule/addValue", {"path": "property.bedroom.items", "value": this.bedroomsSurfaces});
            if(this.bedroomCount <= this.maximumBedroomSurfaces) {
                this.internalBedroomSurface = this.bedroomCount;
            }
        },

        updateBedroomSurface: function(bedroomSurface: number, index: number): void {
            const newBedroomSurface = {
                surface: bedroomSurface
            };
            this.bedroomsSurfaces[index] = newBedroomSurface;
            this.$store.dispatch("FormModule/addValue", {"path": "property.bedroom.items", "value": this.bedroomsSurfaces});            
        },

        removeEmptyBedroomSurface: function() {
            this.bedroomsSurfaces = this.bedroomsSurfaces.filter(bedroomSurface => bedroomSurface.surface !== 0);
            this.$store.dispatch("FormModule/addValue", {"path": "property.bedroom.items", "value": this.bedroomsSurfaces});            
        },

        removeBedroomSurface: function(): void {
            if(this.bedroomCount === 0) {
                this.$store.commit("FormModule/deleteValue", "property.bedroom.items");
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": "property.bedroom.items", "value": this.bedroomsSurfaces});
            }
        },
    },

});
